module.exports = __webpack_public_path__ + "img/actions_white.df3e4785.svg";